"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var camelCaseToDashCase_1 = __importDefault(require("../strings/camelCaseToDashCase"));
var dataAttribute = function (attribute, prefix) {
    var currentName = camelCaseToDashCase_1.default(prefix ? "data-" + prefix + "-" + attribute : "data-" + attribute);
    var currentValue = '';
    var value = function (v) {
        if (typeof v !== 'undefined')
            currentValue = "" + v;
        return currentValue;
    };
    var asObject = function (v) {
        var _a;
        return (_a = {},
            _a[currentName] = value(v),
            _a);
    };
    var assign = function (e) {
        e.setAttribute(currentName, currentValue);
        return e;
    };
    var asString = function (v) {
        return currentName + "=\"" + value(v) + "\"";
    };
    var get = function (e) { return e.getAttribute(currentName); };
    var has = function (e) { return get(e) !== null; };
    var name = function () { return currentName; };
    var remove = function (e) {
        e.removeAttribute(currentName);
        return e;
    };
    return {
        asObject: asObject,
        assign: assign,
        asString: asString,
        get: get,
        has: has,
        name: name,
        remove: remove,
        toString: function () { return asString(); },
        toJSON: function () { return asObject(); },
        value: value,
    };
};
exports.default = dataAttribute;
//# sourceMappingURL=dataAttribute.js.map